import type { NotificationPreferences } from '@indutrust/notification-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Pattern B events for loading and updating the current-user
 * notification preferences singleton.
 */
export const notificationPreferencesEvents = eventGroup({
  source: 'notification.preferences',
  events: {
    loadRequested: type<void>(),
    loadSucceeded: type<{ preferences: NotificationPreferences }>(),
    loadFailed: type<{ error: string }>(),
    updateRequested: type<{
      patch: Partial<NotificationPreferences>;
    }>(),
    updateSucceeded: type<{ preferences: NotificationPreferences }>(),
    updateFailed: type<{ error: string }>(),
  },
});
